import { render, staticRenderFns } from "./PregnantTotalGrowproperties.vue?vue&type=template&id=ba64a4c0"
import script from "./PregnantTotalGrowproperties.vue?vue&type=script&lang=js"
export * from "./PregnantTotalGrowproperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports